'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dUnion$002dAs$002dString$002dCodec$0024$0024anon$00241 from "./io.github.nguyenyou.webawesome.laminar.-Union-As-String-Codec$$anon$1.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$() {
  this.ly = null;
  this.v8 = null;
  $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(this, "type", new $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dUnion$002dAs$002dString$002dCodec$0024$0024anon$00241.$c_Lio_github_nguyenyou_webawesome_laminar_UnionAsStringCodec$$anon$1());
}
export { $c_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ as $c_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ };
$p = $c_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$.prototype = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$h_Lcom_raquo_laminar_keys_HtmlAttr();
$p.constructor = $c_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$;
/** @constructor */
function $h_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$() {
}
export { $h_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ as $h_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ };
$h_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$.prototype = $p;
var $d_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$, "io.github.nguyenyou.webawesome.laminar.CommonKeys$InputInputType$", ({
  jQ: 1,
  cW: 1,
  a6: 1
}));
export { $d_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ as $d_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ };
var $n_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$;
function $m_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$() {
  if ((!$n_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$)) {
    $n_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ = new $c_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$();
  }
  return $n_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$;
}
export { $m_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ as $m_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$ };
